import {useEffect} from "react";

export default function useDeleteLoader() {
    useEffect(() => {
        const loader = document.getElementById('loader');
        if (loader) loader.remove();
    }, []);
}
